import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { setLanguage } from 'containers/Main/actions';
import { makeSelectLocales } from 'containers/Main/selectors';
import useContentfulLocale from 'components/useContentfulLocale';

const withPageLanguage = Component => props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const locales = useSelector(makeSelectLocales());
  const location = useLocation();
  const ctfLocaleFilter = useContentfulLocale();
  const { search, pathname } = location;
  const searchObject = qs.parse(search, {
    ignoreQueryPrefix: true,
  });
  useEffect(() => {
    if (!_isEmpty(locales) && !_isEmpty(_get(searchObject, 'lang'))) {
      const { lang, ...params } = searchObject;
      if (ctfLocaleFilter.locale !== lang) {
        const locale = locales.find(l => l.code === lang);
        const languageCode = locale ? locale.code : 'en-US';
        dispatch(setLanguage(languageCode));
      }

      history.replace(
        `${pathname}${!_isEmpty(params) ? `?${qs.stringify(params)}` : ''}`,
      );
    }
  }, [dispatch, history, locales, searchObject]);

  return <Component {...props} langObject={searchObject} />;
};

export default withPageLanguage;
